/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SegmentModel from 'cio/models/segment';

import TagModel from 'cio/models/tag';

interface SegmentListRowArgs {
  segment: SegmentModel;
  showAudiencesColumn: boolean;
  selected: boolean;
  onSelect: (checked: boolean) => unknown;
  onTagClicked: (tag: TagModel) => unknown;
}

export default class Row extends Component<SegmentListRowArgs> {
  get archiveDate() {
    return this.args.segment.autoArchivedAt ?? this.args.segment.updatedAt;
  }
}
